import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import type Employee from 'modules/employees/store/models/Employee'
import { type TimeoffPolicies } from 'modules/timeoff/store/collections/timeoffPolicies/policies'
import { type PolicyTimelines } from 'modules/timeoff/store/collections/timeoffPolicies/policyTimelines'
import type { PolicyTimelineItem } from 'modules/timeoff/store/models/TimeoffPolicy/PolicyTimeline'

import Item from '../_Item'

interface Props {
  employee: Employee
  currentAssignmentId: number
  selectedTimelineItem: PolicyTimelineItem
  timelineItems: PolicyTimelineItem[]
  onSelectTimelineItem: (item: PolicyTimelineItem) => void
  fetchTimeline: () => Promise<void>
  policies: TimeoffPolicies
  policyTimelines: PolicyTimelines
}

const List = ({
  employee,
  currentAssignmentId,
  timelineItems,
  selectedTimelineItem,
  onSelectTimelineItem,
  fetchTimeline,
  policies,
  policyTimelines,
}: Props) => {
  return (
    <Box gap="s16" padding="s16">
      {timelineItems.map((item: PolicyTimelineItem) => (
        <Item
          key={item.policy_assignment_id}
          employee={employee}
          current={item.policy_assignment_id === currentAssignmentId}
          last={timelineItems[0] === item}
          selected={item.policy_assignment_id === selectedTimelineItem.policy_assignment_id}
          timelineItem={item}
          onSelectTimelineItem={onSelectTimelineItem}
          fetchTimeline={fetchTimeline}
          policies={policies}
          policyTimelines={policyTimelines}
        />
      ))}
    </Box>
  )
}

export default observer(List)
